export const accordionData = [
    {
        title: 'Why Baby Pixel Gator?',
        content: `Baby pixel gator is a collection of 999 unique NFT related to baby gator that aims to bring excitement to the Solana NFT pixel ecosystem, and pay dividends to its holders in a monthly bases.`,
        key: 1
    },
    {
        title: 'How many Baby Pixel Gator will there be?',
        content: `In our first collection (Diapers) there will be a total of 999 unique Baby Pixel Gator NFTs.`,
        key: 2
    },
    {
        title: 'When mint and price?',
        content: `MINT date (12/27/2021) 23:00 UTC and each NFT will have a cost of 0.55 SOL.`,
        key: 3
    },
    {
        title: 'How can I buy one?',
        content: `After mint, there will be one market place available: Magic Eden.`,
        key: 4
    },
    {
        title: 'How many collection will there be?',
        content: `There will be 3 collection, the first being the Diapers collection, each one within 6 month of each other.`,
        key: 5
    },
    {
        title: 'How will the dividends be divided between the holders?',
        content: `The dividends will be divided in 3 groups, each groups  will receive 33% of the earning of that month. These groups will be determent by rarity, being Blue Diamond the 99 most rare BPGs, Red Diamon the 300 rare BPGs, and Pink Diamond the 600 less rare BPGs.`,
        key: 6
    }
  ];